import {
  IconButton,
  Tooltip,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import Iconify from "../Iconify";
import PropTypes from "prop-types";
import moment from "moment";

// ---------------------------------------------------------

const TaskCreatedAt = ({ date }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  if (isLargeScreen) {
    return (
      <Tooltip title={`Created at ${moment(date).format("LLL")}`}>
        <Stack direction="row" spacing={0.8} alignItems="center">
          <Iconify
            sx={{ width: "1rem", height: "1rem", color: "text.secondary" }}
            icon="zondicons:date-add"
          />
          <Typography
            sx={{
              fontWeight: 500,
              whiteSpace: "nowrap",
              fontSize: "12px",
              color: "#637381",
            }}
          >
            {moment(date).format("MMM D, YYYY")}
          </Typography>
        </Stack>
      </Tooltip>
    );
  }

  return (
    <div>
      <Tooltip title={`Created at ${moment(date).format("LLL")}`}>
        <IconButton
          sx={{
            bgcolor: (theme) => theme.palette.action.hover,
            width: "1.9rem",
            height: "1.9rem",
          }}
          size="small"
        >
          <Iconify
            sx={{ width: "1rem", height: "1rem" }}
            icon="zondicons:date-add"
          />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default TaskCreatedAt;

TaskCreatedAt.propTypes = {
  date: PropTypes.string.isRequired,
};
